import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MaterialModule } from '../../../material.module'
import { ColumnComponent } from './grid/column/column.component'
import { ContainerComponent } from './grid/container/container.component'
import { RowComponent } from './grid/row/row.component'
const COMPONENTS = [
  ContainerComponent,
  RowComponent,
  ColumnComponent,
]

@NgModule({
  declarations: [
    ...COMPONENTS,
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    MaterialModule,
    ...COMPONENTS
  ]
})
export class DesignModule { }
